module.exports = __webpack_public_path__ + "assets/xigua.8d5527a1.svg";